import React, { use } from 'react';

import FadedImage from 'src/components/common/faded-image';
import VimeoVideo from 'src/components/common/video/vimeo-video';
import type { FacilityDetailsWithVideo } from 'src/components/facilities/facilities';
import { ClubCmsContent } from 'src/content/club-content-consumer';
import { SiteContext } from 'src/context/site-context';
import imageFade from 'src/helpers/image-fades';
import { colors } from 'src/styling/constants';

import * as styles from './facility-image.module.scss';

const FacilityImage = ({
  facilityType,
  useSmallThumbnails,
  isNav,
}: {
  facilityType: FacilityDetailsWithVideo;
  useSmallThumbnails: boolean;
  isNav?: boolean;
}) => {
  const cmsData = use(ClubCmsContent);
  const navigationContent = cmsData.navigationMenuContent.navigation!;
  const { styling, isHarbour, isDL } = use(SiteContext);
  const textElement = (
    <div className={`${useSmallThumbnails ? 'pa2' : 'pa2 pa4-l'} h-100 flex items-end`}>
      <div
        css={[
          isDL ? styling.fonts.regular : styling.fonts.bold,
          {
            color: 'white',
            textAlign: 'left',
            lineHeight: 1,
            fontSize: isDL && !isNav ? '1.6875rem' : undefined,
          },
        ]}
      >
        {facilityType.displayName}
      </div>
    </div>
  );
  const imageElement = (
    <FadedImage
      className={isDL ? styles.image : 'rounded'}
      image={navigationContent?.[facilityType.cmsKey]}
      fadeType={imageFade.fadeDownwards}
      zoomOnHover
    >
      {textElement}
    </FadedImage>
  );

  const facilityVideo = facilityType.videoId;

  return (
    <div
      css={{
        borderLeft:
          isHarbour && !useSmallThumbnails ? `15px solid ${colors.harbourGold}` : undefined,
        height: '100%',
        width: '100%',
        position: 'relative',
      }}
    >
      {facilityVideo && !useSmallThumbnails ? (
        <>
          {facilityVideo ? (
            <VimeoVideo
              video={{
                videoId: facilityVideo,
                videoPlaceholder: navigationContent?.[facilityType.cmsKey],
              }}
              loop
              muted
              disableAutopause
            >
              {textElement}
            </VimeoVideo>
          ) : null}
        </>
      ) : (
        imageElement
      )}
    </div>
  );
};

export { FacilityImage };
